import React from 'react';


const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ#'.split('');

const AlphabetBar = ({ selectedLetter, availableLetters, disabled, onLetterClick, itemCount }) => {
  return (
    <div className="alphabet-bar">
      <div className="alphabet-bar-letters">
        {ALPHABET.map(letter => {
          const letterLower = letter.toLowerCase();
          const isSelected = selectedLetter === letterLower;
          const isAvailable = availableLetters.includes(letterLower);
          const isDisabled = disabled || !isAvailable;

          return (
            <button
              key={letter}
              className={`alphabet-button ${isSelected ? 'selected' : ''} ${isAvailable ? 'available' : ''}`}
              onClick={() => !isDisabled && onLetterClick(letter)}
              disabled={isDisabled}
              title={!isAvailable ? 'No items' : ''}
            >
              {letter}
            </button>
          );
        })}
      </div>
      <div className="alphabet-bar-count">
        {itemCount} {itemCount === 1 ? 'item' : 'items'}
      </div>
    </div>
  );
};

export default AlphabetBar;
